<p-toolbar class="fixed bottom-0 w-full">
    <span>Copyright © {{currentYear}} Atom Power</span>
</p-toolbar>